import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { Formik } from "formik";
import * as Yup from "yup";
import LoginPage from "./loginPage";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { sendOtp } from "../../services/security.service";
import {
  MOBILE_NUMBER,
  OTP,
  REFERENCE_NUMBER,
  REFERENCE_NUMBER_SUPPLIER,
} from "../../config/cacheKey";
import { Button } from "@material-ui/core";
import { SendOtpRequest, SendOtpResponse } from "../../models/security.model";
import { useHistory } from "react-router-dom";
import { log } from "console";
import NotificationSupp from "../../components/notificationSupp/NotificationSupp";
import NotificationSuppBody from "../notificationSupp/notificationSuppBody";
import { getNoticesResponse } from "../../models/SupplierNotice.model";
import { GetAllLoginNotices } from "../../services/SupplierNotice.service";
import Grid from "@mui/material/Grid";
import { useSelector } from "react-redux";

function _login() {
  const mobileValid = Yup.object({
    mobileNumber: Yup.string().required(),
  });

  const [selectedCount, setSelectedPart] = React.useState();
  const [isBtnNextDeactived, setIsBtnNextDeactived] = useState<boolean>(true);
  const history = useHistory();
  const queryClient = useQueryClient();
  // queryClient.setQueryData(REFERENCE_NUMBER_SUPPLIER, "");
  // const sendOptMutation = useMutation(sendOtp, {
  //   onSuccess: (data: string) => {
  //     if (data) {
  //       queryClient.setQueryData(REFERENCE_NUMBER, data);
  //       history.push("/otp");
  //     }
  //   },
  // });

  React.useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  const sendOptMutation = useMutation(sendOtp, {
    onSuccess: (data: SendOtpResponse) => {
      if (data) {
        queryClient.setQueryData(REFERENCE_NUMBER, data.key);
        queryClient.setQueryData(REFERENCE_NUMBER_SUPPLIER, data.suppliers);
        queryClient.setQueryData(OTP, data);
        history.push("/otp");
      }
    },
  });

  const mobileNumberCodeHandleKeyDown = (event: any) => {
    var key = event.keyCode ? event.keyCode : event.which;
    if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
      event.preventDefault();
    }
    if (
      event.target.value.length >= yupMobileMax &&
      key != 8 &&
      key != 46 &&
      selectedCount === 0
    ) {
      event.preventDefault();
    }
  };

  const currentSelection = (e: any) => {
    setSelectedPart(
      e.target.value.substring(e.target.selectionStart, e.target.selectionEnd)
        .length
    );
  };

  const yupMobileMax = 11;
  const validationSchema = Yup.object().shape({
    mobileNumber: Yup.string()
      .required("شماره موبایل اجباری می باشد")
      .matches(/^[0-9]+$/, "شماره موبایل فقط عدد می باشد"),
    // .min(yupMobileMax, "شماره موبایل یازده رقم است")
    // .max(yupMobileMax, "شماره موبایل فقط یازده عدد است"),
  });
  const [mobile, setMobile] = useState("");
  const getNumber = (e: any) => {
    setMobile(e.target.value);
  };
  const jsonFile = useSelector((state: any) => state.style);
  return (
    <>
      <Box>
        <Typography
          className="iranSansFaNum"
          color={"#1D4A87"}
          fontSize={"1rem"}
          fontWeight={"bold"}
          sx={{
            backgroundColor: "#F9FAFC",
            padding: "18px 30px",
            borderBottom: "1px solid #CFD8DC",
          }}
        >
          <img
            src={jsonFile?.loginLogo ? jsonFile?.loginLogo : "images/LOGOS.png"}
            style={{
              width: "24px",
              height: "24px",
              objectFit: "cover",
              marginLeft: "10px",
            }}
            alt="compony logo"
          />
          سامانه پذیرندگان ارزش آفرین ثمین
        </Typography>
      </Box>
      <Box sx={{ paddingX: { xs: "1rem", sm: "2rem", md: "8rem" } }}>
        <Typography
          className="iranSansFaNum textCenter colorBase  textFont22"
          style={{ marginTop: "5vh", marginBottom: "5vh" }}
        >
          ورود به حساب کاربری
        </Typography>
        <Formik
          initialValues={new SendOtpRequest()}
          // validationSchema={validationSchema}
          onSubmit={(values) => {
            queryClient.setQueryData(MOBILE_NUMBER, mobile);
            // sendOptMutation.mutate(values);
            sendOptMutation.mutate({ mobileNumber: mobile });
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            errors,
            touched,
            handleBlur,
          }) => (
            <form
              onSubmit={handleSubmit}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSubmit();
                }
              }}
            >
              <div style={{ marginTop: "10vh", marginBottom: "5vh" }}>
                <MaterialTextFieldComponent
                  className={"shadowTextField"}
                  autoFocus={true}
                  // helperText={!touched.mobileNumber ? errors.mobileNumber : ""}
                  // error={!touched.mobileNumber && Boolean(errors.mobileNumber)}
                  label="شماره موبایل خود را وارد کنید"
                  placeHolder={"شماره موبایل خود را وارد کنید *"}
                  required={true}
                  inputProps={{ type: "number" }}
                  value={mobile}
                  // onChange={handleChange}
                  onChange={getNumber}
                  name="mobileNumber"
                  id="mobileNumber"
                  onKeyDown={mobileNumberCodeHandleKeyDown}
                  onSelect={currentSelection}
                />
              </div>
              <Button
                style={{ marginTop: "6vh" }}
                type="submit"
                fullWidth
                variant="contained"
                disabled={mobile.length != 11}
                className={
                  mobile.length != 11
                    ? "btnForm deactivatedButton Vazirmatn "
                    : "btnForm activatedButton Vazirmatn "
                }
              >
                ورود
              </Button>
            </form>
          )}
        </Formik>
      </Box>
    </>
  );
}

export default function Login() {
  const jsonFile = useSelector((state: any) => state.style);
  const [dataNotic, setDtaNotic] = useState<getNoticesResponse[]>([]);
  // const { data, isLoading } = useQuery<getNoticesResponse[]>(
  //   "loginNotice",
  //   GetAllLoginNotices,
  //   {
  //     onSuccess(data) {
  //       setDtaNotic(data);
  //     },
  //   }
  // );
  const childForm = <_login />;
  const childFormNotice = dataNotic.map((item: any) => (
    <NotificationSupp data={item} isLogin={true} />
  ));
  // if (isLoading) {
  //   return <></>;
  // }

  return (
    <>
      {Object.keys(dataNotic).length <= 0 ? (
        <>
          {/* <img
            src={jsonFile?.loginLogo ? jsonFile?.loginLogo : "images/LOGO.png"}
            className=" classCenter"
            style={{
              marginTop: "5vh",
              marginBottom: "revert",
              width: "140px",
              height: "100px",
              objectFit: "contain",
            }}
          /> */}
          <Box
            sx={{
              flexGrow: 2,
              overflow: "hidden",
              px: 3,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoginPage
              childForm={childForm}
              onBtnNext={() => console.log("")}
            />
          </Box>
        </>
      ) : (
        <Grid container>
          <Grid item xs={12}>
            <img
              src={
                jsonFile?.loginLogo ? jsonFile.loginLogo : "images/LOGO1.png"
              }
              className="logo classCenter"
              style={{ marginTop: "5vh", marginBottom: "revert" }}
            />
          </Grid>
          <Grid
            container
            xs={12}
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 6, sm: 12, md: 12 }}
            className="bodyForms-ex "
            style={{
              minHeight: "75vh",
              maxHeight: "75vh",
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: "5vh",
              alignItems: "center",
              maxWidth: "130vh",
            }}
          >
            <Grid
              item
              xs={6}
              sm={12}
              md={6}
              style={{
                paddingLeft: "8vh",
                paddingRight: "8vh",
                minHeight: "75vh",
                maxHeight: "75vh",
              }}
              className="BodyFormVerify"
            >
              {childForm}
              {jsonFile?.loginTitle ? (
                <div
                  style={{ marginTop: "12vh" }}
                  className="iranSansMedium textCenter colorTitle textFont12 fontSize "
                  dangerouslySetInnerHTML={{ __html: jsonFile.loginTitle }}
                ></div>
              ) : (
                ""
              )}
              {/* <Typography
                className="iranSansMedium textCenter colorTitle textFont12 fontSize "
                style={{ marginTop: "12vh" }}
              >
                با ورود و یا ثبت نام در
                <span className="colorOk"> "لیزینگ گلرنگ" </span> شما
                <span style={{ textDecoration: "underline" }}>
                  {" "}
                  شرایط و قوانین{" "}
                </span>
                استفاده از سرویس‌های سایت و
                <span style={{ textDecoration: "underline" }}>
                  قوانین حریم خصوصی{" "}
                </span>
                آن را می‌پذیرید
              </Typography> */}
            </Grid>
            <Grid
              item
              xs={6}
              sm={12}
              md={6}
              style={{
                paddingLeft: "3vh",
                paddingRight: "3vh",
                backgroundColor: "#F7F9FF",
                minHeight: "75vh",
                maxHeight: "75vh",
              }}
              className="loginFormVerify"
            >
              <Typography
                className="iranSansMedium textCenter  fontWeight colorBase  textFont20"
                style={{ marginTop: "5vh", marginBottom: "5vh" }}
              >
                اطلاعیه‌های جدید{" "}
              </Typography>
              <Grid
                item
                xs={12}
                className="ScrollHeightLogin "
                style={{ paddingLeft: "3vh", maxWidth: "100%" }}
              >
                {childFormNotice}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}
